import {
  BookOpen,
  Building2,
  Calendar,
  Compass,
  Layers,
  ListOrdered,
  MapPin,
  Package,
  School,
  Shapes,
  Star,
  Users,
} from "lucide-react";

/**
 * Administration → reference-data screens. Shared by the sidebar and the top
 * bar so both menus stay in sync. Admin can edit; DG has read-only access.
 */
export const ADMIN_MENU_ITEMS = [
  { title: "Manage Users", path: "/admin/users", Icon: Users, description: "Reset user passwords" },
  { title: "Products", path: "/admin/products", Icon: Package, description: "Bursary & loan products" },
  { title: "Product Qualifications", path: "/admin/product-qualifications", Icon: Layers, description: "Attach qualifications to products" },
  { title: "Qualifications", path: "/admin/qualifications", Icon: BookOpen, description: "Degree programmes" },
  { title: "Institutions", path: "/admin/institutions", Icon: Building2, description: "Higher learning institutions" },
  { title: "Colleges", path: "/admin/colleges", Icon: School, description: "Colleges per institution" },
  { title: "Campuses", path: "/admin/campuses", Icon: MapPin, description: "Campuses per college" },
  { title: "Study Areas", path: "/admin/study-areas", Icon: Compass, description: "STEM / non-STEM groupings" },
  { title: "Academic Years", path: "/admin/academic-years", Icon: Calendar, description: "Academic year codes" },
  { title: "Combinations", path: "/admin/combinations", Icon: Shapes, description: "Secondary school combinations" },
  { title: "Priority Courses", path: "/admin/priority-courses", Icon: Star, description: "National priority courses" },
  { title: "Education Levels", path: "/admin/education-levels", Icon: ListOrdered, description: "Levels of study" },
];
